module.exports = __webpack_public_path__ + "static/media/vip-hour-tile-3stars.b5696d77.png";